// extracted by mini-css-extract-plugin
export var center = "_5b-2";
export var clickableRow = "_5b-5";
export var expandedRow = "_5b-7";
export var hoverable = "_5b-4";
export var left = "_5b-1";
export var right = "_5b-3";
export var row = "_5b-0";
export var selectedRow = "_5b-6";
export var summaryRow = "_5b-8";